import { type ReactElement } from 'react';
import MuiTooltip, {
  type TooltipProps as MuiTooltipProps,
} from '@mui/material/Tooltip';
import makeStyles from '@mui/styles/makeStyles';
import { commonStyles } from './sharedStyles';

const useDesktopStyles = makeStyles({
  ...commonStyles,
  tooltip: {
    ...commonStyles.tooltip,
    width: ({ maxWidth }: { maxWidth?: string }) => maxWidth || 'inherit',
  },
});

interface TooltipDesktopProps {
  arrow?: boolean;
  children: ReactElement;
  maxWidth?: string;
  placement?: MuiTooltipProps['placement'];
  title?: string | ReactElement;
}

const TooltipDesktop = ({
  arrow = false,
  children,
  maxWidth,
  placement = 'bottom',
  title,
  ...props
}: TooltipDesktopProps) => {
  const classes = useDesktopStyles({ maxWidth });
  return (
    <MuiTooltip
      classes={classes}
      title={title}
      arrow={arrow}
      placement={placement}
      {...props}
    >
      {children}
    </MuiTooltip>
  );
};

export default TooltipDesktop;
export type { TooltipDesktopProps };
